import { buildWidth, getWidthByColumns } from 'app/functions/grid';

/**
 * This function will provide an array of widths which indicate the
 * widths of a box in different breakpoints. It works like "buildsWidth",
 * but the values passed must be number of columns. The width will be
 * calculated using the maximum number of columns defined in the grid
 * configuration. For example, passing 6 will product the width 0.5
 * when using 12 columns.
 *
 * @param sizes
 */
export const buildColumnsWidth = (sizes = {}) =>
    buildWidth(sizes, 12).map(getWidthByColumns);
